export default "__VITE_ASSET__CT_aWT92__"